import { muiTheme } from '@tassat/payments-themes';

export const muiStyles = (theme: typeof muiTheme) => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    fieldMappingDivider: { marginBottom: '3rem' },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    userSelectWrapper: { padding: '12px 0 0 12px' },
    userSelect: {
        minWidth: '60%',
        flexGrow: 1,
        paddingRight: '1rem',
        '& > div': { marginBottom: 0 }
    },
    submitButton: {
        alignSelf: 'center',
        marginTop: '3.5rem',
        marginBottom: '2rem'
    },
    submitError: { alignSelf: 'center' },
    newMappingContainer: {
        paddingTop: '1.25rem',
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    removeMappingContainer: {
        alignSelf: 'center' as 'center',
        paddingBottom: '46px !important'
    },
    apiEnabled: {
        '& label': { alignItems: 'flex-end' },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#ccc'}`,
            borderRadius: '3px'
        }
    },
    roles: {
        '& label': { textAlign: 'center' },
        '& div': { justifyContent: 'center' }
    },
    toggle: {
        '& label': { textAlign: 'center' },
        '& div': { alignSelf: 'center' },
        '& div[role=checkbox]': {
            margin: 'auto' as const,
            marginTop: '.5rem'
        }
    }
});